var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4374 14.3595L28.6949 15.3228",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31213 15.3225L9.56144 14.3611",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1747 10.7282L13.3743 10.5556C13.6454 10.5166 13.8798 10.348 14.0011 10.1048L16.2571 5.5797C16.5625 4.96725 17.4447 4.96725 17.7502 5.5797L20.0061 10.1048C20.1273 10.348 20.3617 10.5166 20.6329 10.5557L25.6775 11.2813C26.3604 11.3795 26.6328 12.2101 26.1387 12.6869L22.4885 16.2093C22.3336 16.3587 22.2451 16.5603 22.2376 16.7702",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7659 16.7774C11.76 16.5654 11.6713 16.3613 11.5148 16.2101L7.86448 12.6878C7.37043 12.2111 7.64302 11.3804 8.32581 11.2822L9.95019 11.0485",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7146 30.6414L5.83131 29.9891C5.52753 29.9203 5.31213 29.6527 5.31213 29.3443V20.5517",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6887 20.572V29.3441C28.6887 29.6526 28.4732 29.9201 28.1695 29.9887L17.1424 32.4838C17.047 32.5054 16.9478 32.5054 16.8524 32.4838L10.9247 31.1427",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 27.0377V32.4203",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 17.9673V24.7829",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9252 21.164L33.0003 19.5877L28.6911 15.3221L17 17.9674M17 17.9674L5.30868 15.3221L0.999634 19.5877L12.7243 22.2L17 17.9674Z",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 17.9673L21.2753 22.1999L23.7149 21.6563",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 0.5V2.48403",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9998 0.5V2.48403",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4005 4.70004L21.1123 6.21993",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4005 4.70004L21.1123 6.21993",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3227 6.88911L26.7874 8.16447",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3227 6.88911L26.7874 8.16447",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5997 4.70004L12.888 6.21993",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5997 4.70004L12.888 6.21993",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67468 6.88911L7.20996 8.16447",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67468 6.88911L7.20996 8.16447",
    stroke: "#000000",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/new.220ca4e23b4524102e086f02ce38af9a.svg";
export { ForwardRef as ReactComponent };